// 로딩 표시 — 영유아 톤(병아리 바운스) + 전자책 페이지 스켈레톤.
// 시각안전: 애니는 ~1Hz(3Hz 미만), prefers-reduced-motion 시 전역 규칙으로 자동 정지.

/** 전역 로딩 — 통통 튀는 병아리 + 안내. role=status로 스크린리더 안내. */
export function ChickLoader({ label = "불러오는 중…" }: { label?: string }) {
  return (
    <div className="chick-loader" role="status" aria-live="polite">
      <span className="chick-loader__chick" aria-hidden="true">
        🐤
      </span>
      <span className="chick-loader__label">{label}</span>
    </div>
  );
}

/** 전자책 펼침 로딩 — 페이지 모양 스켈레톤(은은한 빛 흐름). */
export function BookSkeleton({ spread = false }: { spread?: boolean }) {
  return (
    <div className="book-skel" role="status" aria-live="polite" aria-label="전자책 페이지 불러오는 중">
      <span className="book-skel__page" aria-hidden="true" />
      {spread ? <span className="book-skel__page" aria-hidden="true" /> : null}
    </div>
  );
}
